export const RETRIEVE_ORDER_FAILURE = 'retrieveOrderFailure';
export const INITIALIZE_PICK_A_SEAT = 'initializePickASeat';
export const UPDATE_BRAINTREE_CLIENT_TOKEN = 'updateBraintreeClientToken';
export const SET_ORDER_UPDATING = 'setOrderUpdating';
export const UPDATE_ORDER = 'updateOrder';
export const SET_ORGANIZER_MARKETING_OPT_IN = 'setOrganizerMarketingOptIn';
export const UPDATE_ORDER_EMAIL = 'updateOrderEmail';
export const UPDATE_ORDER_STATUS = 'updateOrderStatus';
export const UPDATE_REDIRECT_INSTRUCTIONS = 'updateRedirectInstructions';
export const RESET_ORDER = 'resetOrder';
export const UPDATE_ORDER_ATTENDEES = 'updateOrderAttendees';
export const SET_ORDER_INSTALLMENTS = 'setOrderInstallments';
export const REMOVE_ORDER_INSTALLMENTS = 'removeOrderInstallments';
export const SET_USER_IS_NEW_SOFT_ACCT = 'setUserInNewSoftAcct';
export const SET_PICK_A_SEAT_BEST_AVAILABLE_WARNING =
    'setPickASeatBestAvailableWarning';
export const CLEAR_PICK_A_SEAT_BEST_AVAILABLE_WARNING =
    'clearPickASeatBestAvailableWarning';
